require('../modules/es6.date.now');
require('../modules/es6.date.to-json');
require('../modules/es6.date.to-iso-string');
require('../modules/es6.date.to-string');
require('../modules/es6.date.to-primitive');
module.exports = Date;



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/core-js/es6/date.js
// module id = pEMT
// module chunks = 0